"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApiError_1 = require("./Error/ApiError");

var Validator =
/** @class */
function () {
  function Validator() {}
  /**
   * Validate the result for the request of a single object
   *
   * @param result
   * @param resolve
   * @param reject
   */


  Validator.prototype.validateSingleResult = function (result, resolve, // eslint-disable-next-line @typescript-eslint/no-unused-vars
  reject) {
    resolve(result);
  };
  /**
   * Validate the result for the request of multiple objects
   *
   * @param result
   * @param resolve
   * @param reject
   */


  Validator.prototype.validateCollectionResult = function (result, resolve, reject) {
    if (Array.isArray(result) || typeof result === 'object') {
      resolve(result);
    } else {
      reject(new ApiError_1.ApiError("Response was ok, but decoded body is not an array but " + typeof result, result));
    }
  };

  return Validator;
}();

exports.Validator = Validator;